import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material"; 
// -- Legacy: gapi for Google Calendar init (do not remove) --
// import { gapi } from "gapi-script";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { STATE_DISTRICT_MAP } from "../../utils/discoverApi";
import { stateByCode } from "../../utils/usStates";
// -- Legacy: FEC elections fetch (do not remove) --
// import { getElectionsByState, fetchUserAddress } from "../../utils/utils";
import { fetchUserAddress } from "../../utils/utils";
// -- Legacy: calendar util used by FEC flow (do not remove) --
// import { addElectionToGoogleCalendar } from "../../utils/calendarUtils";
import { fetchDWElections } from "../../utils/democracyWorksApi";

// -- Legacy: CalendarModal used by FEC/Civic flow in parent (do not remove) --
// -- DemocracyWorksElections renders its own CalendarModal internally --
// import CalendarModal from "../../components/UpcomingElectionsComponents/CalendarModal";
import BallotBriefModal from "./BallotBriefModal";
// -- Legacy: FEC & Google Civic list components (do not remove) --
// import FecElectionsList from "./FecElectionsList";
// import GoogleCivicElectionList from "./GoogleCivicElectionList";
import DemocracyWorksElections from "./DemocracyWorksElections";
import { theme } from "../../theme/colors";
import { FaChevronRight } from "react-icons/fa";

import "./UsersUpcomingElections.scss";
// import BallotReadyElections from "./BallotReadyElections";

// -- Legacy: Google Calendar / Civic API constants (do not remove) --
// const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
// const API_KEY = process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY;
// const DISCOVERY_DOCS = [
//   "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
// ];
// const SCOPES = "https://www.googleapis.com/auth/calendar.events";

function districtForDiscoverNav(stateCode, districtRaw) {
  if (!stateCode || !districtRaw) return null;
  if (STATE_DISTRICT_MAP[stateCode] === 1) return null;
  const digits = String(districtRaw).replace(/\D/g, "");
  if (!digits) return null;
  const n = parseInt(digits, 10);
  if (Number.isNaN(n) || n < 1) return null;
  const max = STATE_DISTRICT_MAP[stateCode];
  if (max && n > max) return null;
  return String(n).padStart(2, "0");
}

const UsersUpcomingElections = () => {
  const { userState, userDistrict } = useUser();
  const [formData, setFormData] = useState({
    street_1: "",
    city: "",
    state: "",
    zipcode: "",
  });
  // -- Legacy: Google Civic + FEC state (do not remove) --
  // const [electionData, setElectionData] = useState(null);
  // const [dbElections, setDbElections] = useState([]);
  const [dwElections, setDwElections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // -- Legacy: modalOpen used by parent CalendarModal in FEC/Civic flow (do not remove) --
  // const [modalOpen, setModalOpen] = useState(false);
  const [ballotModalOpen, setBallotModalOpen] = useState(false);
  const [ballotModalContent, setBallotModalContent] = useState("");
  const [ballotModalTitle] = useState("");
  const [toast, setToast] = useState({ open: false, message: "", severity: "error" });

  const navigate = useNavigate();

  const stateForDiscover = formData.state || userState || null;
  const districtForDiscover = districtForDiscoverNav(stateForDiscover, userDistrict);

  const fullAddress =
    formData.street_1 &&
    formData.city &&
    formData.state &&
    formData.zipcode
      ? `${formData.street_1}, ${formData.city}, ${formData.state} ${formData.zipcode}`
      : null;

  // -- Legacy: gapi init (do not remove) --
  // useEffect(() => {
  //   const initGapiClient = () => {
  //     gapi.load("client:auth2", async () => {
  //       await gapi.client.init({
  //         apiKey: API_KEY,
  //         clientId: CLIENT_ID,
  //         discoveryDocs: DISCOVERY_DOCS,
  //         scope: SCOPES,
  //       });
  //     });
  //   };
  //   initGapiClient();
  // }, []);

  useEffect(() => {
    fetchUserAddress(setFormData, setError, setLoading);
  }, []);

  // -- Legacy: Google Civic voterinfo fetch (do not remove) --
  // useEffect(() => {
  //   const fetchElectionData = async () => {
  //     if (!fullAddress) return;
  //     setLoading(true);
  //     setError("");
  //     try {
  //       const response = await fetch(
  //         `https://www.googleapis.com/civicinfo/v2/voterinfo?address=${encodeURIComponent(
  //           fullAddress
  //         )}&key=${API_KEY}`
  //       );
  //       const data = await response.json();
  //       if (data.error) {
  //         setError(data.error.message);
  //       } else {
  //         setElectionData(data);
  //       }
  //     } catch (err) {
  //       setError("Failed to fetch election data.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   if (fullAddress) fetchElectionData();
  // }, [fullAddress]);

  // -- Legacy: FEC elections fetch (do not remove) --
  // useEffect(() => {
  //   const fetchDbElections = async () => {
  //     setLoading(true);
  //     try {
  //       const data = await getElectionsByState();
  //       if (data) {
  //         setDbElections(data);
  //       }
  //     } catch (err) {
  //       console.error("Error loading DB elections:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchDbElections();
  // }, []);

  useEffect(() => {
    const loadDWElections = async () => {
      setLoading(true);
      try {
        const data = await fetchDWElections();
        setDwElections(data);
      } catch (err) {
        console.error("Error loading DW elections:", err);
      } finally {
        setLoading(false);
      }
    };
    loadDWElections();
  }, []);

  // -- Legacy: calendar/ballot modal handlers used by FEC/Civic flow (do not remove) --
  // const handleOpenCalendarModal = () => setModalOpen(true);
  // const handleCloseCalendarModal = () => setModalOpen(false);
  // const handleOpenBallotModal = (title, content) => {
  //   setBallotModalTitle(title);
  //   setBallotModalContent(content);
  //   setBallotModalOpen(true);
  // };
  const handleCloseBallotModal = () => {
    setBallotModalOpen(false);
    setBallotModalContent("");
  };

  // -- Legacy: transformedElection for Google Civic CalendarModal (do not remove) --
  // const transformedElection = {
  //   election_name: electionData?.election?.name || "Election Day",
  //   election_date: electionData?.election?.electionDay || "",
  //   election_notes:
  //     "Polling place: " +
  //     (electionData?.pollingLocations?.[0]?.address?.line1 || "N/A"),
  // };

  // const addDbElectionToCalendar = async (election) => {
  //   if (!gapi || !gapi.client || !election?.election_date || !election?.election_name) return;

  //   const event = {
  //     summary: election.election_name,
  //     description: election.election_notes || "Upcoming election from CivixThread",
  //     start: {
  //       date: election.election_date,
  //     },
  //     end: {
  //       date: election.election_date,
  //     },
  //   };

  //   try {
  //     await gapi.client.calendar.events.insert({
  //       calendarId: "primary",
  //       resource: event,
  //     });
  //     alert("Election added to your Google Calendar!");
  //   } catch (error) {
  //     console.error("Error adding DB election to calendar:", error);
  //     alert("There was a problem adding this election to your calendar.");
  //   }
  // };

  // -- Legacy: addUsersElectionToCalendar used by FEC/Civic flow (do not remove) --
  // const addUsersElectionToCalendar = async (election) => {
  //   try {
  //     const link = await addElectionToGoogleCalendar(election);
  //     if (link) {
  //       window.open(link, "_blank", "noopener,noreferrer");
  //     } else {
  //       setToast({ open: true, message: "Failed to create calendar event.", severity: "error" });
  //     }
  //   } catch (error) {
  //     console.error("Error adding to calendar:", error);
  //     setToast({ open: true, message: "There was a problem adding this election to your calendar.", severity: "error" });
  //   }
  // };

  return (
    <Box className="elections" sx={{ p: 0 }}>
     
      {loading && <CircularProgress sx={{ display: "block", mx: "auto", mt: 3 }} />}
      {error && <Typography sx={{ display: "none" }} color="error" textAlign="center">{error}</Typography>}

      {!fullAddress && (
        <Box className="elections__no-address" sx={{ p: 2, mt: 1, backgroundColor: "#fef3c7", borderRadius: 2, display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" sx={{ color: "#0f172a", flex: 1 }}>Please add an address to see upcoming elections.</Typography>
          <Button
            variant="contained"
            size="small"
            onClick={() => navigate("/account-details#location")}
            sx={{ backgroundColor: "var(--primary-color)", borderRadius: 2, textTransform: "none", fontWeight: 600, boxShadow: "none", "&:hover": { boxShadow: "none" } }}
          >
            Add Address
          </Button>
        </Box>
      )}

      <Box className="elections__explainer" sx={{ mt: 1, mb: 1, display: "flex", gap: 1, p: 2, backgroundColor: "rgba(0,0,0,0.02)", borderRadius: 2 }}>
        <Typography variant="body2" sx={{ color: "#0f172a", fontSize: "0.85rem", lineHeight: 1.5 }}>
          <strong style={{ color: "#0f172a" }}>CivixThread</strong> surfaces upcoming elections personalized to your address using the{" "}
          <a href="https://www.democracy.works/" target="_blank" rel="noreferrer" style={{ color: "var(--primary-color)", fontWeight: 600 }}>Democracy Works</a>{" "}
          Elections API, covering local, state, and federal races with registration deadlines and voting guidance.
        </Typography>
      </Box>

      {/* -- Legacy: FEC + Google Civic explainer (do not remove) --
      <Box className="elections__explainer" sx={{ mt: 1, mb: 1, display: "flex", gap: 1, p: 2, backgroundColor: "rgba(0,0,0,0.02)", borderRadius: 2 }}>
        <Typography variant="body2" sx={{ color: "#0f172a", fontSize: "0.85rem", lineHeight: 1.5 }}>
          <strong style={{ color: "#0f172a" }}>CivixThread</strong> pulls official election dates from <a href="https://www.fec.gov/" target="_blank" rel="noreferrer" style={{ color: "var(--primary-color)", fontWeight: 500 }}>FEC.gov</a>, so you never miss a primary or general election.
          The <a href="https://developers.google.com/civic-information" target="_blank" rel="noreferrer" style={{ color: "var(--primary-color)", fontWeight: 500 }}>Google Civic Information API</a> fills in ballot details, such as polling locations, contests, and measures. Usually 2–4 weeks before election day.
        </Typography>
      </Box>
      */}

      {/* <BallotReadyElections
        address="1248 W 29th St, Los Angeles, CA 90007"
        token={process.env.REACT_APP_BALLOTREADY_TOKEN}
        includeDistricts={[ 
          "District 34",
          "District 37"
        ]}
      />   */}

      {/* -- Legacy: FEC + Google Civic rendering (do not remove) --
      {(dbElections.length > 0 || electionData) ? (
        <>
          {dbElections.length > 0 && (
            <FecElectionsList
              elections={dbElections} 
            />
          )}
          {electionData && (
            <GoogleCivicElectionList
              electionData={electionData} 
            />
          )}
        </>
      ) : (
        !loading && (
          <Box className="elections__no-elections" mt={2} sx={{ textAlign: "center", p: 4, backgroundColor: "#f8fafc", borderRadius: 3 }}>
            <Typography sx={{ fontWeight: 600, color: "#0f172a", mb: 1 }}>No upcoming elections</Typography>   
            <Typography variant="body2" sx={{ color: "#0f172a" }}>Election details typically appear 2–4 weeks before election day.</Typography>
          </Box>
        )
      )}
      */}

      {dwElections.length > 0 ? (
        <DemocracyWorksElections
          elections={dwElections}
          showBallotData
          showSignupNudge={false}
        />
      ) : (
        !loading && (
          <Box className="elections__no-elections" mt={2} sx={{ textAlign: "center", p: 4, backgroundColor: "#f8fafc", borderRadius: 3 }}>
            <Typography sx={{ fontWeight: 600, color: "#0f172a", mb: 1 }}>No upcoming elections</Typography>   
            <Typography variant="body2" sx={{ color: "#0f172a" }}>Election details typically appear 2–4 weeks before election day.</Typography>
          </Box>
        )
      )}

      {/* -- Legacy: parent CalendarModal used by FEC/Civic flow (do not remove) -- */}
      {/* <CalendarModal open={modalOpen} onClose={handleCloseCalendarModal} election={null} /> */}
      <BallotBriefModal open={ballotModalOpen} onClose={handleCloseBallotModal} title={ballotModalTitle} content={ballotModalContent} />

      {(() => {
        const stateEntry = stateByCode(stateForDiscover);
        if (!stateEntry) return null;
        return (
          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: "0.8rem",
              color: "#0f172a",
              lineHeight: 1.5,
            }}
          >
            Share the public {stateEntry.name} elections guide:{" "}
            <RouterLink
              to={`/elections/${stateEntry.slug}`}
              style={{
                color: "var(--primary-color)",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              /elections/{stateEntry.slug} →
            </RouterLink>
          </Typography>
        );
      })()}

      <Button
        variant="contained"
        fullWidth
        onClick={() => navigate("/discover", {
          state: {
            filterType: "candidates",
            accountType: "candidate",
            state: stateForDiscover,
            district: districtForDiscover,
          }
        })}
        sx={{
          mt: 3,
          py: 1.5,
          backgroundColor: theme.primary,
          color: "#fff",
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.95rem",
          display: "flex",
          justifyContent: "space-between",
          px: 3,
          "&:hover": { backgroundColor: theme.primaryHover }
        }}
        endIcon={<FaChevronRight style={{ fontSize: "0.9rem" }} />}
      >
        Follow candidate money
      </Button>
      <Snackbar open={toast.open} autoHideDuration={5000} onClose={() => setToast(t => ({ ...t, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
        <Alert onClose={() => setToast(t => ({ ...t, open: false }))} severity={toast.severity} variant="filled">{toast.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default UsersUpcomingElections;
